export default __webpack_public_path__ + "static/media/demo_3.d16e0fd8.png";